import { Box, Button, Popover, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useStyles } from "./styles";

const CustomPopover = ({ element, onChange, title = "" }) => {
  const anchorRef = useRef(null);
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [state, setState] = useState({});

  useEffect(() => {
    let defaultState = {};
    for (const obj in element?.default) {
      defaultState[obj] = element.default[obj];
    }
    setState(defaultState);
  }, [element]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleClose = () => {
    onChange(state);
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "popover-textfields" : undefined;

  return (
    <Box className={classes.root}>
      <Button
        title={title}
        ref={anchorRef}
        className={classes.openBtn}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {element?.name}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        PaperProps={{
          style: {
            width: anchorRef.current ? anchorRef.current.clientWidth : null,
          },
        }}
      >
        <Box px={3} py={2}>
          {element?.default &&
            Object.keys(element.default).map((data) => {
              return (
                <TextField
                  sx={{ width: "100%" }}
                  margin="normal"
                  size="small"
                  id={data}
                  label={data}
                  name={data}
                  value={state[data]}
                  variant="outlined"
                  onChange={(e) => handleChange(e)}
                />
              );
            })}
        </Box>
      </Popover>
    </Box>
  );
};

export default CustomPopover;
